import React from 'react';
import { Podcast } from '../types';

interface PodcastDetailModalProps {
  podcast: Podcast;
  onClose: () => void;
  onViewEpisodes: () => void;
}

const PodcastDetailModal: React.FC<PodcastDetailModalProps> = ({ podcast, onClose, onViewEpisodes }) => {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content podcast-detail-modal" onClick={(e) => e.stopPropagation()}>
        <div className="podcast-detail-header">
          {podcast.imageUrl && (
            <img src={podcast.imageUrl} alt={podcast.title} className="podcast-detail-cover" />
          )}
          <div className="podcast-detail-info">
            <h2>{podcast.title}</h2>
            <p className="podcast-detail-author">{podcast.author}</p>
          </div>
        </div>

        <div className="podcast-detail-body">
          <div className="detail-section">
            <label>Description:</label>
            <p>{podcast.description || 'No description available'}</p>
          </div>

          <div className="detail-section">
            <label>RSS Feed:</label>
            <a
              href={podcast.feedUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="podcast-detail-feed-link"
            >
              {podcast.feedUrl}
            </a>
          </div>

          <div className="detail-section">
            <label>Added:</label>
            <p>{new Date(podcast.addedAt).toLocaleDateString()}</p>
          </div>
        </div>

        <div className="podcast-detail-actions">
          <button onClick={onViewEpisodes} className="submit-btn">
            View Episodes
          </button>
          <button onClick={onClose} className="cancel-btn">
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default PodcastDetailModal;
